/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import { isFileSystemAccessApiSupported } from '../../../core/capabilities/browser-capabilities';
import ErrorName from '../../../core/error/error-name';
import FormatEnum from '../../../core/format-enum';
import {
  getUpdateUrlOpaqueInfo,
  parseUpdateUrlConfig
} from '../../../core/update-url-config/update-url-hash-config';
import UpdatePlatform from '../../../platform/update-platform';

/**
 * @import { Info } from '../../../core/update-url-config/update-url-hash-config'
 * @import { AppManager as IAppManager } from '../../../core/app'
 */

/**
 * Správce aplikace pro standardní webové technologie.
 * @implements {IAppManager<Info>}
 */
export default class AppManager {
  constructor() {
    this.updateUrl = location.href;
    /** @type {IAppManager['hasIdleTime']} */
    this.hasIdleTime = Promise.resolve(false);
    /** @type {IAppManager['hasSupportedBrowser']} */
    this.hasSupportedBrowser = isFileSystemAccessApiSupported();
  }

  /** @type {IAppManager['exit']} */
  async exit() {
    // #484 - Prázdná akce na platformě web, ochrana proti ztrátě řízení (původně se načítalo about:blank)
  }

  /** @type {IAppManager['finishUpdate']} */
  async finishUpdate() {}

  /** @type {IAppManager['getCustomKey']} */
  async getCustomKey() {
    return await 'web';
  }

  /** @type {IAppManager['getCustomReport']} */
  async getCustomReport() {
    return await {};
  }

  /** @type {IAppManager['getFormat']} */
  async getFormat() {
    return await FormatEnum.HTML;
  }

  /** @type {IAppManager['getIdleTime']} */
  async getIdleTime() {
    const error = new Error('Getting idle is not supported.');
    error.name = ErrorName.NotSupportedError;
    throw await error;
  }

  /** @type {IAppManager['getUpdatePlatform']} */
  async getUpdatePlatform() {
    // Web má jedinou platformu, bez verzování apod.
    return await UpdatePlatform.Web;
  }

  /** @type {IAppManager['getUpdateUrl']} */
  async getUpdateUrl() {
    return await this.updateUrl;
  }

  /** @type {IAppManager['getUpdateUrlOpaqueInfo']} */
  async getUpdateUrlOpaqueInfo() {
    return getUpdateUrlOpaqueInfo(await this.getUpdateUrl());
  }

  /** @type {IAppManager['parseUpdateUrlConfig']} */
  parseUpdateUrlConfig(info) {
    return parseUpdateUrlConfig(info);
  }

  /** @type {IAppManager['resetIdleTime']} */
  async resetIdleTime() {
    const error = new Error('Resetting idle time is not supported.');
    error.name = ErrorName.NotSupportedError;
    throw await error;
  }

  /** @type {IAppManager['setAppInfo']} */
  async setAppInfo(appInfo) {}

  /** @type {IAppManager['setCustomSettings']} */
  async setCustomSettings(customSettings) {}

  /** @type {IAppManager['update']} */
  async update(url, info) {
    // #484 - Prázdná akce na platformě web, ochrana proti případné změně domény
  }
}
